module.exports = __webpack_public_path__ + "images/6cd7be1a37dd56c519a4027c0818b296-notallowed-tv.svg";